import React, { useState, useRef } from 'react';
import Modal from './ui/Modal';

const CreativeCircleCard = ({
    image,
    title,
    subtitle = "C2 Circle",
    link = "#!",
    description = "Join this creative circle to connect with like-minded individuals, share ideas, and collaborate on exciting projects."
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const triggerRef = useRef(null);

    return (
        <>
            <div className="project-two__single">
                <div className="project-two__img">
                    <img src={image} alt={title} width={"250px"} height={"500px"} style={{ display: "block", objectFit: "cover" }} />
                </div>
                <div className="project-two__content">
                    <p className="project-two__sub-title">{subtitle}</p>
                    <h3 className="project-two__title">
                        <button
                            ref={triggerRef}
                            onClick={() => setIsModalOpen(true)}
                            style={{
                                background: 'none',
                                border: 'none',
                                // color: 'inherit',
                                font: 'inherit',
                                cursor: 'pointer',
                                padding: 0,
                                textDecoration: 'none'
                            }}
                        >
                            {title}
                        </button>
                    </h3>
                </div>
            </div>

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={title}
                primaryAction={{
                    label: 'Join Circle',
                    onClick: () => {
                        setIsModalOpen(false);
                        window.dispatchEvent(new CustomEvent('openGoogleFormModal'));
                    }
                }}
                secondaryAction={{
                    label: 'Close',
                    onClick: () => setIsModalOpen(false)
                }}
            >
                <p><strong>{subtitle}</strong></p>
                <p>{description}</p>
                <p>This circle provides a space for creatives to:</p>
                <ul style={{ paddingLeft: '20px', marginTop: '12px' }}>
                    <li>Share knowledge and experiences</li>
                    <li>Collaborate on projects</li>
                    <li>Network with peers</li>
                    <li>Access exclusive resources and events</li>
                </ul>
            </Modal>
        </>
    );
};

export default CreativeCircleCard;
